<template>
  <div class="saas-feature section-space--ptb_90 bg-gray">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title text-center section-space--mb_60">
            <h2 class="font-weight--light mb-15 wow move-up">Features for Cosmetic Compliance</h2>
            <span class="section-text wow move-up">Boost your regulatory compliance process</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-for="item in items" :key="item.id" class="col-lg-4 col-md-6 wow move-up">
          <div class="service-grid">
            <div class="ht-service-box--one style-03 text-center">
              <a>
                <div class="content">
                  <i class="service_text fa mb-5 mt-5" :class="item.icon" style="font-size:40px;"></i>
                  <h6 class="heading">{{ item.heading }}</h6>
                  <div class="service_text">{{ item.text }}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SassFeature",
  data() {
    return {
      items: [
        {
          icon: "fa-cogs",
          heading: "PIF Automation",
          text: "Generate PIF documents on-the-go for your business' products.",
        },
        {
          icon: "fa-flask",
          heading: "Ingredients Assessment",
          text:
            "Assess and create ingredients based on data from EU COSING regulation.",
        },
        {
          icon: "fa-file-invoice",
          heading: "Template Power-up",
          text:
            "Create advanced documents for your custom need with our template syntax.",
        },
        {
          icon: "fa-users",
          heading: "Collaboration",
          text:
            "Invite your team and work together to create regulatory PIF documents.",
        },
        {
          icon: "fa-cloud",
          heading: "In the Cloud",
          text: "SaaS powered app which is available wherever and whenever.",
        },
        {
          icon: "fa-fire",
          heading: "Free to Go",
          text: "Ready-made and free to get you going, scale up if needed.",
        },
      ],
    };
  },
};
</script>
